import EventInfo from "../../../../components/sections/front/user-events-collections/EventInfo";
import EventManageForm from "../../../../components/sections/front/user-events-collections/EventManageForm";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

const EventManage = () => {
  const navigate = useNavigate();
  const { event, eventLoading, selectedLanguage, updateEvent, eventRefetch } =
    useOutletContext();

  return (
    <div className="w-full relative flex flex-col lg:flex-row items-start gap-4 xl:gap-6">
      <div className="flex-shrink-0 w-full lg:w-72 xl:w-96 lg:top-24 lg:sticky">
        <EventInfo details={event} />
      </div>
      <div className="relative flex-shrink overflow-hidden w-full md:w-auto">
        <EventManageForm
          data={event || {}}
          updateEvent={updateEvent}
          eventRefetch={eventRefetch}
        />
      </div>
    </div>
  );
};

export default EventManage;
